function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

(function ($) {
  $.hashParameters = function (str) {
    var qso = {};
    var qs = str || document.location.hash; // Check for an empty querystring

    if (qs == "") {
      return qso;
    } // Normalize the querystring


    qs = qs.replace(/(^\#)/, '').replace(/;/g, '&');

    while (qs.indexOf("&&") != -1) {
      qs = qs.replace(/&&/g, '&');
    }

    qs = qs.replace(/([\&]+$)/, ''); // Break the querystring into parts

    qs = qs.split("&"); // Build the querystring object

    for (var i = 0; i < qs.length; i++) {
      var qi = qs[i].split("=");

      if (qso[qi[0]] != undefined) {
        // If a key already exists then make this an object
        if (typeof qso[qi[0]] == "string") {
          var temp = qso[qi[0]];

          if (qi[1] == "") {
            qi[1] = null;
          } else {
            qi[1] = decodeURIComponent(qi[1]);
          }

          qso[qi[0]] = [];
          qso[qi[0]].push(temp);
          qso[qi[0]].push(decodeURIComponent(qi[1]));
        } else if (_typeof(qso[qi[0]]) == "object") {
          if (qi[1] == "") {
            qi[1] = null;
          } else {
            qi[1] = decodeURIComponent(qi[1]);
          }

          qso[qi[0]].push(decodeURIComponent(qi[1]));
        }
      } else {
        // If no key exists just set it as a string
        if (qi[1] == "") {
          qi[1] = null;
        } else {
          qi[1] = decodeURIComponent(qi[1]);
        }

        qso[qi[0]] = qi[1] == null ? null : decodeURIComponent(qi[1]);
      }
    }

    return qso;
  };
})(jQuery);